import { Box, Button, Stack, Typography } from "@mui/material";

interface Props {
  open: boolean;
  attempts: number;
  message?: string;
  onRejoin: () => void;
  onClose: () => void;
}

export default function RejoinPrompt({
  open,
  attempts,
  message,
  onRejoin,
  onClose,
}: Readonly<Props>) {
  if (!open) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 5,
      }}
    >
      <Stack
        sx={{
          gap: 2,
          bgcolor: "background.paper",
          color: "text.primary",
          p: 4,
          borderRadius: 2,
          width: 360,
          textAlign: "center",
          boxShadow: 6,
        }}
      >
        <Typography variant="h6">Connection lost</Typography>
        <Typography
          sx={{
            color: "text.secondary",
            fontSize: 14,
          }}
        >
          {message ?? "We couldn't reach the meeting server."}
          {attempts > 0 && ` (attempt ${attempts})`}
        </Typography>
        <Stack
          direction="row"
          sx={{
            gap: 1.5,
            justifyContent: "center",
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            Leave
          </Button>
          <Button variant="contained" onClick={onRejoin}>
            Rejoin
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
